// extracted by mini-css-extract-plugin
module.exports = {"termsContainer":"style_termsContainer__PeYYY","Arcade_termsContainer":"style_Arcade_termsContainer__iPRAs"};